var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"release-type-label",class:{ 'release-type-album': _vm.type === 'album', 'release-type-single': _vm.type === 'single' }},[_vm._v("\n  "+_vm._s(_vm.type === 'album' ? 'アルバム配信' : 'シングル配信')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }